@use "variables" as *;

.salesStatusArrived {
  color: $bg-primary-color;
  background-color: $grayscale-50-color;
}
